const { MinimogThemeStyles, MinimogThemeScripts } = window;

class QuickView {
  constructor() {
    this.modal = new MinimogTheme.Modal();
    this.isOpen = false;
    this.isLoading = false;

    // Event delegation for quick view button
    addEventDelegate({
      selector: ".m-product-quickview-button",
      handler: (e, target) => {
        e.preventDefault();
        if (this.isLoading) return;
        this.target = target;
        this.toggleLoading(true);
        let productHandle = target.dataset.productHandle;
        if (!productHandle && target.dataset.productUrl) {
          productHandle = target.dataset.productUrl.split("/products/")[1]?.split("?")[0];
        }
        if (productHandle) this.loadProductQuickView(productHandle);
        else this.toggleLoading(false);
      },
    });

    // Subscribe to cart update events
    window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, () => {
      if (this.modal) this.modal.close();
    });
    window.MinimogEvents.subscribe('ON_MODAL_CLOSED', (modal) => {
      this.close();
    });
  }

  // Load product quick view HTML
  loadProductQuickView(productHandle) {
    if (this.isOpen) {
      this.modal && this.modal.close(); // Close any existing modal before loading a new one
    }
    this.isLoading = true;
    fetchSection("product-quickview", { url: `${window.MinimogSettings.base_url}products/${productHandle}` })
      .then((html) => {
        this.modalContent = html.querySelector("#MainProduct-quick-view__content");
        if (!this.modalContent) {
          throw new Error("Quick view content missing in fetched HTML.");
        }
        const productInfo = html.querySelector("product-info");
        const colorScheme = productInfo?.dataset?.colorScheme || "";
        this.modal.appendChild(this.modalContent);
        const isMobile = window.matchMedia("(max-width: 767px)").matches;
        this.modal.setWidth(isMobile ? "100vw" : "960px");
        const modalContent = this.modal.modal.querySelector(".m-modal--content");
        if (modalContent) {
          if (isMobile) {
            modalContent.style.height = "100dvh";
            modalContent.style.maxHeight = "100dvh";
            modalContent.style.overflow = "auto";
          } else {
            modalContent.style.height = "auto";
            modalContent.style.maxHeight = "none";
            modalContent.style.overflow = "visible";
          }
        }

        const sectionWrapper = this.modal.modal.querySelector("#MainProduct-quick-view__content");
        if (sectionWrapper) {
          if (isMobile) {
            sectionWrapper.style.height = "auto";
            sectionWrapper.style.minHeight = "auto";
          } else {
            sectionWrapper.style.height = "auto";
            sectionWrapper.style.minHeight = "45rem";
          }

          sectionWrapper.querySelectorAll("script").forEach((oldScriptTag) => {
            const newScriptTag = document.createElement("script");
            Array.from(oldScriptTag.attributes).forEach((attribute) => {
              newScriptTag.setAttribute(attribute.name, attribute.value);
            });
            newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
            oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
          });
        }

        this.modal.open();
        this.modal.setSizes(`m-gradient ${colorScheme}`);

        this.toggleLoading(false);
        this.isOpen = true;
        this.isLoading = false; // Reset loading state
      })
      .then(() => {
        document.dispatchEvent(
          new CustomEvent('tcustomizer-custom-show-quick-view', {
            detail: { productHandle: this.target.dataset.productHandle }
          })
        );

        document.dispatchEvent(
          new CustomEvent("quick-view:loaded", {
            detail: { productUrl: this.target.dataset.productHandle }
          })
        );
      })
      .catch((error) => {
        console.error("Error loading product quick view:", error);
        this.toggleLoading(false);
        this.isLoading = false;
      });
  }

  // Close the quick view modal
  close() {
    this.isOpen = false;
  }

  // Toggle loading spinner on the target element
  toggleLoading(isLoading) {
    if (isLoading) {
      this.target.classList.add("m-spinner-loading");
    } else {
      this.target.classList.remove("m-spinner-loading");
    }
  }
}

// Initialize the QuickView instance
MinimogTheme.ProductQuickView = new QuickView();
